import React from 'react';
import Panel from './Panel';

function Content(props) {
  return (
    /*#__PURE__*/
    React.createElement(Panel, Object.assign({}, props, {
      useTextStyle: true
    }))
  );
}

export default Content;